import { InstructionEmailForm } from '@/features/ap_payees/components/DocInstructionMenu/types';
import { useTranslation } from '@/i18n';
import { FormInput, Label } from '@moneyforward/ap-frontend-components';
import { FC, memo, useMemo } from 'react';
import { Control } from 'react-hook-form';
import styles from '../styles.module.scss';
import { validationRules } from '@/features/ap_payees/components/DocInstructionMenu/Helpers/validationRules';
export type TInstructionSubjectProps = {
  control: Control<InstructionEmailForm>;
};
export const InstructionSubject: FC<TInstructionSubjectProps> = memo(
  ({ control }) => {
    const { t } = useTranslation();
    const titleRules = useMemo(
      () => ({
        required: {
          value: true,
          message: t('common.validation.required'),
        },
        validate: validationRules.requiredNotAllowEmpty(
          t('common.validation.required')
        ),
      }),
      [t]
    );

    return (
      <div>
        <div className={styles.label}>
          <Label text={t('send_instruction_email_subject')} htmlFor='subject' />
        </div>
        <div className={styles.content}>
          <FormInput<InstructionEmailForm>
            name='subject'
            control={control}
            rules={titleRules}
            inputId='subject'
          />
        </div>
      </div>
    );
  }
);
InstructionSubject.displayName = 'InstructionSubject';
